// extracted by mini-css-extract-plugin
export default {"Container":"Loading_Container__E4y2+","Text":"Loading_Text__68hJA","ShowOpacity":"Loading_ShowOpacity__KR7uP"};